(function ($, Global) {
    function BtnScrollUpComponent() {
        // Déclaration class objet
    }

	BtnScrollUpComponent.prototype.initEvents = function () {
		this.publishers();
	}

	BtnScrollUpComponent.prototype.publishers = function () {
		$(window).on('scroll', function () {
			$('.btn-scroll-up')[$(window).scrollTop() > 100 ? 'addClass' : 'removeClass']('visible');
		});

		$(document).on('click', '.btn-scroll-up', function () {
			$('html, body').animate({
				scrollTop: 0
			}, 'slow');
		});
	}

	Global.BtnScrollUpComponent = BtnScrollUpComponent;
}(jQuery, window));